import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ordersComponent } from '../components/orders/orders.component';
import { ViewTmsOrderComponent } from '../components/tms-order/view-tms-order/view-tms-order.component';
import { TripOrderComponent } from '../components/trip-order/trip-order.component';
import { EndTripComponent } from '../components/end-trip/end-trip.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
    data: { title: ' Order List' }
  },
  {
    path: 'orders',
    component: ordersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },
  {
    path: '',
    component: ordersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },
  {
    path: 'order-view',
    component: ViewTmsOrderComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },
  {
    path: 'order-view/:id',
    component: ViewTmsOrderComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },
  {
    path: 'order-trip/:id',
    component: TripOrderComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders-Trip' }
  },
  {
    path: 'end-trip/:id',
    component: EndTripComponent,
    // canActivate: [AuthGuard],
    data: { title: 'End-Trip' }
  },
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ordersRoutingModule { }
